import axios from 'axios';
const accessToken = localStorage.getItem("accessToken");
const tokenDefault = process.env.REACT_APP_TOKEN_DEFAULT;

export default axios.create({
  // baseURL: 'http://localhost:8081/',
  baseURL: process.env.REACT_APP_API_URL_DEV,
  // baseURL: process.env.REACT_APP_API_URL,
  headers: { Authorization: 'Bearer '.concat(accessToken ?? tokenDefault) }
});